import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';



function AppHeader() {

   // Textfarbe
   const MyTextColor = {
      color: "white",   
      fontFamily: "Arial",
   } 

    return (
      <Navbar expand="lg" style={{backgroundColor: "#6083bf"}}>
      <Container>
        <Navbar.Brand style={MyTextColor} href="#home">RaLiWa</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link style={MyTextColor} href="/home">Home</Nav.Link>
            <Nav.Link style={MyTextColor} href="/messagebox">MessageBox</Nav.Link>            
            <Nav.Link style={MyTextColor} href="/contact">Kontakt</Nav.Link>            
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    )
}

export default AppHeader;